import { setToastMessage } from "../redux/MainReducer";
import { store } from "../redux/Store";

export const successToast = (data) => {
  store.dispatch(
    setToastMessage({
      severity: "success",
      message: data,
      messageStatus: true,
    })
  );
};

export const errorToast = (data) => {
  let message = data;
  if (typeof data === "object" && data !== null) {
    message = data.message || data.error || JSON.stringify(data);
  }
  store.dispatch(
    setToastMessage({
      severity: "error",
      message: sanitizeUserError(message),
      messageStatus: true,
    })
  );
};

export const sanitizeUserError = (
  message,
  fallback = "Something went wrong. Please try again."
) => {
  const text =
    typeof message === "string"
      ? message
      : message?.message || message?.error || "";
  if (
    /D1 API|SQLITE_|not authorized to access this service|code['"]?\s*:\s*7403|ECONNREFUSED|cloudflare/i.test(
      String(text)
    )
  ) {
    return fallback;
  }
  if (!text || String(text).startsWith("[") || String(text).startsWith("{")) {
    return fallback;
  }
  return String(text);
};

export const infoToast = (data) => {
  store.dispatch(
    setToastMessage({
      severity: "info",
      message: data,
      messageStatus: true,
    })
  );
};
